<script>
import {mapGetters} from "vuex";
import { format } from 'date-fns'
import { fr, enUS } from 'date-fns/locale'
import {computed} from "vue";

const locale = computed(() => i18n.global.locale.value)

export default {

  computed : {

      blockUI(){
          return new KTBlockUI(document.querySelector("#kt_content"), {
              message: '<div class=""><span class="spinner-border text-primary"></span> ' + i18n.global.t('text_loading')+ '...</div>',
          })
      }
  },

  methods: {
    $bodyScript (src) {
      if (document.querySelector("script[src='" + src + "']")) { return }
      const script = document.createElement('script')
      script.setAttribute('src', src)
      script.setAttribute('type', 'text/javascript')
      document.body.appendChild(script)
    },

    $headerLink (href) {
      if (document.querySelector("link[href='" + href + "']")) { return }
      const link = document.createElement('link')
      link.setAttribute('href', href)
      link.setAttribute('rel', 'stylesheet')
      link.setAttribute('type', 'text/css')
      document.head.appendChild(link)
    },

    $delLink (href) {
      let el = document.querySelector("link[href='" + href + "']")
      if(el){
        el.remove()
      }
    },

    $delScript (src) {
      let el = document.querySelector("script[src='" + src + "']");
      if(el){
        el.remove();
      }
    },

    $goBack() {
          this.$router.go(-1)
      },

      $goTo(url) {
          this.$router.push(url)
      },

      $loading(id){
          $("#"+id).attr("data-kt-indicator","on")
          $("#"+id).attr("disabled",true)
      },

      $stopLoading(id){
          $("#"+id).attr("data-kt-indicator",false)
          $("#"+id).attr("disabled",false)
      },

    $formatNumber(n) {
      // format number 1000000 to 1,234,567
      return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    // $formatLocaleNumber(n) {
    //   if( this.$i18n.locale === 'fr'){
    //     return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    //   }else{
    //     return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    //   }
    //
    // },

    $formatLocaleNumber(n) {
      if (this.$i18n.locale === 'fr') {
        return n.toLocaleString('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 2 });
      } else {
        return n.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 2 });
      }
    },



    $currencyFormatEur(value) {
      return new Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'}).format(value)
    },

    $formatCurrency(currency, price) {
      if (currency && currency.iso) {
        return new Intl.NumberFormat('fr-FR', {
          style: 'currency',
          currency: currency.iso.toUpperCase(),
        }).format(price)
      }
      return String(price)
    },

    $convertDate(date, join) {
      if (join === undefined) join = '/'
      let DateFormat = new Date(date.toDate())
      if (DateFormat) {
        return [this.$pad(DateFormat.getDate()), this.$pad(DateFormat.getMonth() + 1), DateFormat.getFullYear()].join(join)
      }
    },

    $formatLocalAmount(amount) {
      const locale = this?.$i18n?.locale || 'fr';
      const options = {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      };

      const parsedAmount = parseFloat(amount);

      if (!isNaN(parsedAmount) && Number.isFinite(parsedAmount)) {
        if (Number.isInteger(parsedAmount)) {
          return parsedAmount.toLocaleString(locale, options);
        } else {
          if (locale === 'fr') {
            return parsedAmount.toLocaleString('fr-FR', options);
          } else {
            return parsedAmount.toLocaleString('en-US', options);
          }
        }
      }

      // Retourner la valeur d'origine si la conversion a échoué
      return amount;
    },

    $pad(s) {
      return (s < 10) ? '0' + s : s;
    },

    $formatDate(d) {
      var month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [day, month,year].join('/');
    },

    $formatToDate(date){
      const locale = this.$i18n?.locale || 'fr'
      return new Date(date).toLocaleDateString(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour : 'numeric',
        minute : 'numeric'
      })
    },

    $formatMyDateWithoutHour(date){
      return format(new Date(date), 'dd, MMMM yyyy', {
        locale: this.$i18n.locale === 'fr' ? fr : enUS
      })
    },

    $formatBirthdayDate(date){
      return format(new Date(date), 'dd, MMMM', {
        locale: this.$i18n.locale === 'fr' ? fr : enUS
      })
    },


    $formatSampleMyDateWithoutHour(date){
      return format(new Date(date), 'dd-MM-yyyy', {
        locale: this.$i18n.locale === 'fr' ? fr : enUS
      })
    },

    $formatDateShowOnlyYear(date){
      return format(new Date(date), 'yyyy', {
        locale: this.$i18n.locale === 'fr' ? fr : enUS
      })
    },

    $startLoadingPage(){
        if(!this.blockUI?.isBlocked()){
            this.blockUI.block();
        }
    },

    $endLoadingPage(){
        if(this.blockUI?.isBlocked()){
            this.blockUI.release();
        }
    },

    $removeTrailingSlash(str) {
        if (str.endsWith("/")) {
          return str.slice(0, -1);
        }
        return str;
    },

    $addYearToPrefixe(str) {
      if (str.endsWith("/")) {
        str = str.slice(0, -1);
      }

      return str + "/" + (new Date()).getFullYear()

    },

    $incrementValue(value){
      return String(value + 1).padStart(5, '0')
    }

  }
}

export function formattedLocalAmount(amount) {
  const local = locale.value;
  const options = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  };

  const parsedAmount = parseFloat(amount);

  if (!isNaN(parsedAmount) && Number.isFinite(parsedAmount)) {
    if (Number.isInteger(parsedAmount)) {
      return parsedAmount.toLocaleString(local, options);
    } else {
      if (local === 'fr') {
        return parsedAmount.toLocaleString('fr-FR', options);
      } else {
        return parsedAmount.toLocaleString('en-US', options);
      }
    }
  }

  // Retourner la valeur d'origine si la conversion a échoué
  return amount;
}

export function removeProtocol(url) {
  if (!url) {
    return ''
  }

  return url.replace(/(^\w+:|^)\/\//, '')
}

export function getUrlProtocol(url) {
  if (!url) {
    return ''
  }

  let arrayUrl = url.split('//')

  return arrayUrl[0]
}

export function getTenantId(){
  let host = window.location.host;
  let parts = host.split('.');
  let subDomainLength = 3; // without www
  let wwwSubDomainLength = 4; // with www

  if(window.location.hostname === 'localhost'){
    return 'app.'
  }

  if(parts.length === subDomainLength && parts[0] !== 'www'){
    return parts[0] + "."
  }else if(parts.length === wwwSubDomainLength && parts[0] === 'www'){
    return parts[1] + "."
  }

  if(parts[0] && parts[0] !== "www"){
    return parts[0] + "."
  }

  return window.location.hostname === 'localhost' ? 'app.' : ""
}

export function isSubDomain(){
  let host = window.location.host;
  host = host.replace('http://', '')
  host = host.replace('https://', '')
  host = host.replace('www.', '')

  let parts = host.split('.');
  let domain_length = process.env.VUE_APP_DOMAIN_LENGTH

  let isSubdomain = false

  if(parseInt(parts?.length) === parseInt(domain_length) + 1){
    isSubdomain = true
  }
  return isSubdomain

}


export function getProtocol() {
  return window.location.protocol + '//';
}

export function formatDate(date) {
  if(!date){
    return ''
  }

  const d = new Date(date)
  var month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;
  return [day, month,year].join('-');

}


export function formatDateWithSeparator(date, separator = '-') {
  if (!date) return ''

  const s = String(date)

  // ISO format: YYYY-MM-DD or YYYY-MM-DDThh:mm:ss...
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (iso) {
    const [, year, month, day] = iso
    return [day, month, year].join(separator)
  }

  // Already DD-MM-YYYY or DD/MM/YYYY
  const dmy = s.match(/^(\d{2})[-\/](\d{2})[-\/](\d{4})/)
  if (dmy) {
    const [, day, month, year] = dmy
    return [day, month, year].join(separator)
  }

  return s
}

export function createFormData(data) {
  const formData = new FormData();
  for (const dataKey in data) {
    formData.append(dataKey, data[dataKey]);
  }
  return formData;
}

</script>
